document.addEventListener('click', (event) => {
  if (!event.target.closest('#userDropdownMenuButton')) return;

  document.getElementById('userDropdownMenu')?.classList.toggle('show');
});
